import {
  BUTTON_TEXT,
  EDITION_MODAL_INFO_TITLE,
  HOURS_PER_WEEK_STAT,
  LISTS_PER_WEEK_STAT,
  TOTAL_WEEKS_STAT,
  StatType,
} from './constants';

export interface ConfigModalInfo {
  infoTitle: string;
  buttonText: string;
  stats: {
    hoursPerWeek: StatType;
    listsPerWeek: StatType;
    totalWeeks: StatType;
  };
}

export const getConfigModalInfo = (): ConfigModalInfo => {
  return {
    infoTitle: EDITION_MODAL_INFO_TITLE,
    buttonText: BUTTON_TEXT,
    stats: {
      hoursPerWeek: HOURS_PER_WEEK_STAT,
      listsPerWeek: LISTS_PER_WEEK_STAT,
      totalWeeks: TOTAL_WEEKS_STAT,
    },
  };
};
